import React from 'react'
import { Pressable, Text, View } from 'react-native'

import { IMAGE } from '@ui-kit/assets/images/index.native'
import Icon from '@ui-kit/components/Icon'
import { cardInfo } from '@ui-kit/components/cards/CardInfo/styles'
import { borderColor } from '@ui-kit/styles/colors'

import type { Props } from './types'

const CardInfo = (props: Props): JSX.Element => {
  const { container, header, title, description, descriptionContainer } = cardInfo({
    compact: Boolean(props.compact),
  })
  const isPressable = Boolean(props.onPress)
  const ComponentWrapper = isPressable ? Pressable : View

  return (
    <ComponentWrapper
      className={container({ className: borderColor({ color: 'uiGreyMedium' }) })}
      onPress={props.onPress}
      testID={props.testID}
    >
      <View className={header()}>
        <Text className={title()}>{props.title}</Text>
        {isPressable ? <Icon imgSrc={IMAGE.icons.small.action.chevronRight_24} /> : null}
      </View>
      <View className={descriptionContainer()}>
        <Text className={description()}>{props.description}</Text>
      </View>
    </ComponentWrapper>
  )
}

export default CardInfo
